import isType from './is-type';
var isDate = function (value) {
    return isType(value, 'Date');
};
export default isDate;
//# sourceMappingURL=is-date.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-date.js
// module id = 486
// module chunks = 3